var off = require('./dom-event').off;
module.exports = function () {
  var self = this;
  var element = self.element;
  off(element, 'keypress', self.eventHandler);
  off(element, 'keydown', self.eventHandler);
  off(element, 'keyup', self.eventHandler);
};